"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _commonReact = require("@devsta/common-react");

var _reactRouterDom = require("react-router-dom");

var _reactApollo = require("react-apollo");

var _ResetPassword = _interopRequireDefault(require("../components/ResetPassword"));

var _api = require("../api");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ResetPassword = function ResetPassword(_ref) {
  var history = _ref.history;
  var tempToken = new URLSearchParams(history.location.search).get('t');
  return _react.default.createElement(_reactApollo.ApolloConsumer, null, function (apolloClient) {
    return _react.default.createElement(_commonReact.RequestProvider, {
      requests: {
        changePassword: (0, _api.changePasswordApi)()
      }
    }, function (_ref2) {
      var changePassword = _ref2.changePassword;
      return _react.default.createElement(_ResetPassword.default, {
        history: history,
        tempToken: tempToken,
        apolloClient: apolloClient,
        changePassword: changePassword
      });
    });
  });
};

var _default = (0, _reactRouterDom.withRouter)(ResetPassword);

exports.default = _default;